import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { CommonModule } from '@angular/common';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IonicSelectableModule } from 'ionic-selectable';
import { SharedModule } from './shared/shared.module';


import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { Camera } from '@ionic-native/camera/ngx';

import { environment } from './../environments/environment';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { SearchFilterPipe } from './services/filter-search.pipe';
import { NgOtpInputModule } from  'ng-otp-input';
import { IonicStorageModule } from '@ionic/storage-angular';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { HTTPInterceptor } from 'src/http-interceptor';
import { PaymentFailureComponent } from '../payment-failure/payment-failure.component';
import { PaymentSuccessComponent } from '../payment-success/payment-success.component';

@NgModule({
  declarations: [
    AppComponent,
    SearchFilterPipe,
    PaymentFailureComponent,
    PaymentSuccessComponent
    
    
    

  ],
  entryComponents: [],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    IonicSelectableModule,
    NgOtpInputModule,
    CommonModule,
   
    
    IonicStorageModule.forRoot(),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideStorage(() => getStorage()),
    provideFirestore(() => getFirestore()),  

  ],
  providers: [
    Camera,SocialSharing,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {  provide: HTTP_INTERCEPTORS,
      useClass: HTTPInterceptor,
      multi: true,},
  ],

  exports: [SharedModule, IonicSelectableModule],
  bootstrap: [AppComponent],
})
export class AppModule { }
